import ReactDOM from 'react-dom/client';

import { App } from '@/app';

import '@/app/styles/index.css';

import { storiesGhostMock } from '@/pages/dashboard/stories/api/ghost-mocks';

import { initializeAnalytics } from '@/shared/lib/analytics';
import { registerGhostMock } from '@/shared/lib/dev-ghost-mocks';
import { initSentry } from '@/shared/lib/sentry';
import { initTheme } from '@/shared/lib/theme';

// Apply the persisted light/dark theme before first paint (no flash).
initTheme();

// DEV-only ghost-mode mocks that pages own (statically false in production, so they are dropped).
if (import.meta.env.DEV) {
  registerGhostMock('/stories', storiesGhostMock);
  // The writing assistant's estimate basis (the shared metered-AI pricing endpoint).
  registerGhostMock('/ai/pricing', storiesGhostMock);
}

// Initialize Sentry before rendering the app (like in Flutter main.dart)
initSentry();

// Initialize RudderStack analytics
initializeAnalytics();

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
